import { APPTRANSLATIONSCORE } from 'projects/shared/lib/i18n/translations-core';

/**
 * Collection of translations which may be referenced and used within this specific project.
 *
 * Usage:
 *
 * import { APPTRANSLATIONS } from 'projects/shared/lib/i18n/translations';
 *
 * public appTranslations = APPTRANSLATIONS;
 *
 * <span>{{ appTranslations[name] }}</span>
 *
 * appTranslations.name
 *
 * These shared/base entries are mapped into this projectto be used and may be extended with further entries.
 */
export const APPTRANSLATIONS: { [key: string]: string } = {
  ...APPTRANSLATIONSCORE
};
